import { Context } from '@nuxt/types';

const customer = async (ctx: Context) => {
  const { locale } = ctx.app.$channelConfig('settings');
  await ctx.app.$instanceConnector('customer').init({ locale: locale.split('_')[0] || 'lt' });
};

export default customer;
